import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Input, Button, Select, message, Upload } from "antd";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import DiscountCreationSchema from "../../../../Schemas/DiscountCreationSchema";

import {
  createDiscount,
  updateDiscount,
} from "../../../../Services/DiscountService";
import { useHistory } from "react-router-dom"; // useHistory for v5

function DiscountCreationForm({
  data = {},
  callReFetch,
  isEditMode = false,
  onClose,
}) {
  const formik = useFormik({
    initialValues: {
      name: data.name || "",
      discountValue: data.discountValue || "",
    },
    enableReinitialize: true,
    validationSchema: DiscountCreationSchema,
  });

  const [loading, setLoading] = useState(false);
  const history = useHistory(); // useHistory for v5

  const handleSubmit = async () => {
    const values = formik.values;
    if (
      isEmpty(values.name) ||
      values.discountValue === "" ||
      values.discountValue == null     ) {
      console.log(values);
      message.error("Please insert all required data.");
      return;
    }

    try {
      if (!isEditMode) {
        await createDiscount(values);
        message.success("Discount created successfully");
        onClose();
        callReFetch();
        formik.resetForm();
        // Redirect to the discount list or wherever you want
      } else {
        const updatedDiscount = await updateDiscount(data._id, values);
        callReFetch();
        message.success(
          updatedDiscount?.data?.message || "Discount updated successfully"
        );
        onClose(); // Close the modal
      }
    } catch (err) {
      console.error("Error: ", err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    }
  };

  const { values } = formik;
  const titleText = isEditMode ? "Discount Detail" : "Create Discount";
  const submitButtonText = isEditMode ? "Update" : "Create";

  return (
    <div>
      <h2
        className="title"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {titleText}
      </h2>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Nama & discountValue Tidak boleh duplicate
      </p>
      <p style={{ display: "flex", justifyContent: "center" }}>
        discountValue hanya di antara 0 - 99
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form
          layout="vertical"
          style={{
            maxWidth: "80vw",
            backgroundDiscount: "#F5F5F5",
            borderRadius: "8px",
            padding: "16px",
          }}
        >

          <Form.Item label="Name" required>
            <Input
              style={{ width: "100%" }}
              placeholder="Enter discount name"
              onChange={(e) => formik.setFieldValue("name", e.target.value)}
              value={values.name}
            />
          </Form.Item>
          <Form.Item label="Discount Value" required>
            <Input
              name="discountValue"
              placeholder="Enter discount value"
              onChange={(e) => {
                let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                let num = Number(value);

                if (num >= 0 && num <= 99) {
                  formik.setFieldValue("discountValue", num);
                } else if (num > 99) {
                  formik.setFieldValue("discountValue", 99); // Cap at 99
                } else {
                  formik.setFieldValue("discountValue", ""); // Reset if out of range
                }
              }}
              value={formik.values.discountValue}
              addonAfter="%"
            />
          </Form.Item>
          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="button"
              className="bg-black"
              onClick={handleSubmit}
              style={{ marginRight: "10px" }}
            >
              {submitButtonText}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

DiscountCreationForm.propTypes = {};

export default DiscountCreationForm;
